import { render, staticRenderFns } from "./AwaitingExportSalesIndicators.vue?vue&type=template&id=37870868&"
import script from "./AwaitingExportSalesIndicators.vue?vue&type=script&lang=js&"
export * from "./AwaitingExportSalesIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports